import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_rescue_equipment_ready_use_when_confined_space'

export const dataPointDefinition = {
  retracedId: 'no_rescue_equipment_ready_use_when_confined_space',
  name: 'No rescue equipment ready for use (when a confined space entry occurs)',
  description:
    'Rescue equipment should be onsite for an active confined space entry (CSE) or rented when needed or brought onsite by a third party responsible for rescue services during CSE.',
  meta: {
    slcpMeta: {
      key: 'hs-bui-53x',
      number: 'HS-BUI-13-7',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-bui-46',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-13,Yes',
      machineShowHide: '[2],hs-13,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-bui-53x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29810,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
